// Area graphes
export const areaColor = '#6366f1'
export const areaColorRed = '#fca5a5'

// Reference lines
export const referenceLineStroke = '3 10'

export const referenceLineColor1 = '#6366f1'
export const referenceLineColor2 = '#fca5a5'
